import { render } from "./CharacterLoad.vue?vue&type=template&id=4534c0c7&scoped=true"
import script from "./CharacterLoad.vue?vue&type=script&lang=js"
export * from "./CharacterLoad.vue?vue&type=script&lang=js"

import "./CharacterLoad.vue?vue&type=style&index=0&id=4534c0c7&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4534c0c7"]])

export default __exports__